"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ucareUtils = void 0;
const getUrl = (uuid) => {
    if (!uuid)
        return null;
    return `https://ucarecdn.com/${uuid}/`;
};
const getImageUrl = (uuid, config) => {
    const baseUrl = getUrl(uuid);
    if (!baseUrl)
        return null;
    if (config === null || config === void 0 ? void 0 : config.width)
        return `${baseUrl}-/resize/${config === null || config === void 0 ? void 0 : config.width}x/`;
    return baseUrl;
};
exports.ucareUtils = {
    getUrl,
    getImageUrl,
};
//# sourceMappingURL=uploadcareUtils.js.map